import { Component, Input } from '@angular/core';

@Component({
  selector: 'pub-service-duration-and-price',
  templateUrl: './service-duration-and-price.component.html',
  styleUrls: ['./service-duration-and-price.component.scss'],
})
export class ServiceDurationAndPriceComponent {
  @Input() duration!: string | undefined;
  @Input() price!: number | undefined;
  @Input() hideClock = false;
}
